import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  width: 80%;
  max-width: 80%;
  max-height: 90%;

  @media only screen and (max-width: 600px) {
    width: 90%;
    max-width: 90%;
  }
`;

export const Heading = styled.h2`
  font-size: 2rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colours.accent};
`;
